import { Outlet } from 'react-router-dom';

/** No persistent tab strip - the Dashboard itself is the hub, with clickable cards linking to each area, same icon-tile pattern already used on the Staff Dashboard. Removed per explicit feedback that 9 tabs was too many to navigate. */
export function HRWorkspaceLayout() {
  return (
    <div className="page">
      <Outlet />
    </div>
  );
}
